import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  { name: 'name', label: 'Name', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'value', label: 'Amount', levelType: AutoLockFormsLevelType.FIELD },
];

export const otherExpensesForm = {
  name: FormNames.OTHER_EXPENSES,
  label: 'Other Expenses',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
